var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.266v2.61C22 21.151 20.208 23 18 23H6c-2.208 0-4-1.848-4-4.125v-2.609a.51.51 0 0 1 .5-.516h1.667c.275 0 .5.232.5.516v2.61c0 .76.596 1.374 1.333 1.374h12c.738 0 1.333-.614 1.333-1.375v-2.609a.51.51 0 0 1 .5-.516H21.5c.275 0 .5.232.5.516zM7.37 6.926l2.963 3.333V2.031c0-.571.446-1.031 1-1.031h1.334c.554 0 1 .46 1 1.031v8.228l2.962-3.334a.982.982 0 0 1 1.446-.034l.913.94c.387.4.391 1.053.004 1.457l-6.284 6.531a.977.977 0 0 1-1.42 0L5.012 9.293a1.054 1.054 0 0 1 .004-1.457l.912-.941a.977.977 0 0 1 1.442.03z",
    fill: "#8F9BB3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.2158cd0a.svg";
export { ForwardRef as ReactComponent };